module.exports = __webpack_public_path__ + "img/futurePoints1.b2636766.png";